// Pinia 인스턴스와 어드민 공통 상태(useAppStore)를 정의. accessToken은 hq_login으로 발급받은 JWT 값
import { createPinia, defineStore } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

interface IAppState {
  accessToken: string
}

export const useAppStore = defineStore('carrot-replay-app-store', {
  state: (): IAppState => ({
    accessToken: '',
  }),

  getters: {
    hasAuth(): boolean {
      return Boolean(this.accessToken)
    },
  },

  actions: {
    setAccessToken(token: string): void {
      this.accessToken = token
    },

    clearAuthData(): void {
      this.accessToken = ''
    },
  },

  persist: {
    key: 'carrot-replay-app',
    storage: localStorage,
    pick: ['accessToken'],
  },
})

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

export default pinia
